import React from 'react';
import { Helmet } from 'react-helmet-async';

const ImageProtection = () => {
  return (
    <Helmet>
      <style>
        {`
          /* Disable right-click context menu only on protected images */
          img.protected-image {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            -webkit-user-drag: none;
            -moz-user-drag: none;
            user-drag: none;
            pointer-events: none;
          }
          
          /* Re-enable pointer events for interactive elements */
          img.clickable, img.hero-image, .post-hero-image, .hotel-image img, .place-image img {
            pointer-events: auto !important;
          }
          
          /* Disable text selection and dragging only for protected image containers */
          .image-container.protected {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            position: relative;
          }
          
          /* Overlay protection only for protected images */
          .image-container.protected::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            background: transparent;
            pointer-events: none;
          }
          
          /* Watermark overlay only for watermarked images */
          .image-container.watermarked::after {
            content: 'Safarnamah.com';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: rgba(255, 255, 255, 0.3);
            font-size: 24px;
            font-weight: bold;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
            z-index: 2;
            pointer-events: none;
            font-family: Arial, sans-serif;
          }
          
          /* Prevent print screen */
          @media print {
            img {
              display: none !important;
            }
            .image-container::after {
              content: 'Images protected - Visit Safarnamah.com';
              display: block !important;
            }
          }
          
          /* DevTools protection styles */
          .no-select {
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -khtml-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
          }
          
          /* Blur protection when dev tools are open */
          .blur-when-inspecting img {
            filter: blur(5px);
            transition: filter 0.3s ease;
          }
        `}
      </style>
      
      <script>
        {`
          (function() {
            // Helper function to check if image should be protected
            function isProtectedImage(element) {
              return element.classList.contains('protected-image') ||
                     element.closest('.protected') ||
                     element.closest('.about-team-photo') ||
                     element.closest('.blog-content') ||
                     element.tagName === 'IMG' && element.getAttribute('data-protect') === 'true';
            }
            
            // Disable right-click context menu only for protected images
            document.addEventListener('contextmenu', function(e) {
              if (e.target.tagName === 'IMG' && isProtectedImage(e.target)) {
                e.preventDefault();
                return false;
              }
            });
            
            // Disable drag and drop only for protected images
            document.addEventListener('dragstart', function(e) {
              if (e.target.tagName === 'IMG' && isProtectedImage(e.target)) {
                e.preventDefault();
                return false;
              }
            });
            
            // Disable text selection only for protected images
            document.addEventListener('selectstart', function(e) {
              if (e.target.tagName === 'IMG' && isProtectedImage(e.target)) {
                e.preventDefault();
                return false;
              }
            });
            
            // Only disable specific keyboard shortcuts for protected images
            document.addEventListener('keydown', function(e) {
              // Only prevent shortcuts if focused on a protected image
              if (e.target.tagName === 'IMG' && isProtectedImage(e.target)) {
                // Disable Ctrl+S (Save Page) when focused on protected image
                if (e.ctrlKey && e.keyCode === 83) {
                  e.preventDefault();
                  return false;
                }
                
                // Disable Ctrl+A (Select All) on protected images
                if (e.ctrlKey && e.keyCode === 65) {
                  e.preventDefault();
                  return false;
                }
              }
            });
            
            // Simple console warning instead of aggressive DevTools detection
            console.log('%cImages are protected!', 'color: red; font-size: 20px; font-weight: bold;');
            
            // Console warning
            console.log('%cSTOP!', 'color: red; font-size: 50px; font-weight: bold;');
            console.log('%cThis is a browser feature intended for developers. Images and content on this site are protected by copyright.', 'color: red; font-size: 16px;');
            
            // Image protection for specific protected images only
            function protectSpecificImages() {
              const protectedImages = document.querySelectorAll('img.protected-image, .protected img, .about-team-photo img');
              
              protectedImages.forEach(img => {
                // Add protection classes only to specific images
                img.classList.add('no-select');
                
                // Only wrap protected images in protective containers
                if (!img.parentElement.classList.contains('image-container')) {
                  const container = document.createElement('div');
                  container.className = 'image-container protected watermarked no-select';
                  img.parentNode.insertBefore(container, img);
                  container.appendChild(img);
                }
              });
            }
            
            // Run protection when DOM is ready
            if (document.readyState === 'loading') {
              document.addEventListener('DOMContentLoaded', protectSpecificImages);
            } else {
              protectSpecificImages();
            }
            
            // Re-run protection when new images are added
            const observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                  protectSpecificImages();
                }
              });
            });
            
            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
            
          })();
        `}
      </script>
    </Helmet>
  );
};

export default ImageProtection;